import trainingGetters from "./getters.js";
import trainingMutations from "./mutations.js";
import trainingActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      trainingLoaded: null,
      enrollmentsLoaded: false,
      modules: [],
      learningContent: [],
      competencyTests: [],
      enrollments: [],
      requiredActions: [],
    };
  },
  getters: trainingGetters,
  mutations: trainingMutations,
  actions: trainingActions,
};
